var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "3.455%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D961C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6858FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "139.8%",
    height: "139.8%",
    x: "-19.9%",
    y: "-19.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0452633304 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 44,
    cy: 44,
    r: 44
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M41.5 30C50.613 30 58 37.387 58 46.5S50.613 63 41.5 63 25 55.613 25 46.5 32.387 30 41.5 30zm0 7.333a9.167 9.167 0 100 18.334 9.167 9.167 0 000-18.334zM59.5 25a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceit);
export default __webpack_public_path__ + "static/media/faceit.54a148ce9e8793ff767eb7ad09aa0f8a.svg";
export { ForwardRef as ReactComponent };